import { useId } from 'react';
import './FlagToggle.css';

type Props = {
  active: boolean;
  onToggle: () => void;
  className?: string;
  ariaLabel?: string;
};

export function UsaFlag({ width = 22, height = 15 }: { width?: number; height?: number }) {
  const clipId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flag-icon-svg"
      style={{ display: 'block', borderRadius: '2.5px', overflow: 'hidden' }}
      aria-hidden="true"
    >
      <defs>
        <clipPath id={clipId}>
          <rect width="22" height="15" rx="2.5" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        {/* Red background */}
        <rect width="22" height="15" fill="var(--flag-us-red)" />
        {/* 6 White stripes */}
        <rect y="1.15" width="22" height="1.15" fill="var(--flag-us-white)" />
        <rect y="3.46" width="22" height="1.15" fill="var(--flag-us-white)" />
        <rect y="5.77" width="22" height="1.15" fill="var(--flag-us-white)" />
        <rect y="8.08" width="22" height="1.15" fill="var(--flag-us-white)" />
        <rect y="10.38" width="22" height="1.15" fill="var(--flag-us-white)" />
        <rect y="12.69" width="22" height="1.15" fill="var(--flag-us-white)" />
        {/* Blue canton */}
        <rect width="9.2" height="8.08" fill="var(--flag-us-blue)" />
        {/* Stars */}
        <circle cx="2.0" cy="1.6" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="4.6" cy="1.6" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="7.2" cy="1.6" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="3.3" cy="3.0" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="5.9" cy="3.0" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="2.0" cy="4.4" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="4.6" cy="4.4" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="7.2" cy="4.4" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="3.3" cy="5.8" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="5.9" cy="5.8" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="2.0" cy="7.1" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="4.6" cy="7.1" r="0.55" fill="var(--flag-us-white)" />
        <circle cx="7.2" cy="7.1" r="0.55" fill="var(--flag-us-white)" />
        {/* Border */}
        <rect width="22" height="15" rx="2.5" fill="none" stroke="var(--neo-black)" strokeWidth="1" />
      </g>
    </svg>
  );
}

/**
 * Badge button with US flag that flips a word/card/game between español and
 * inglés. Purely a display/audio toggle — never persisted, never touches
 * word data.
 */
export function FlagToggle({ active, onToggle, className, ariaLabel }: Props) {
  const classes = ['flag-toggle', 'icon-btn', active ? 'is-active' : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      aria-pressed={active}
      aria-label={ariaLabel ?? (active ? 'Volver al español' : 'Ver en inglés')}
      title={active ? 'Volver al español' : 'Ver en inglés'}
    >
      <UsaFlag />
    </button>
  );
}
